import { Card, FormControl, Grid, InputLabel, MenuItem, Select, Divider } from "@mui/material";
import { getRequestGroup } from "api/routes";
import { getReservedSubTimes } from "api/routes";
import { reserveSubTime } from "api/routes";
import { updatePatientInformation } from "api/routes";
import { addReservedSubTimes } from "api/routes";
import { getReservedDays } from "api/routes";
import { getSubRequestGroup } from "api/routes";
import { getInsurance } from "api/routes";
import { getReservedTimesNoDayId } from "api/routes";
import Loading from "components/Loading";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { buildReservationSlots, findInitialReservationSlot, findReservationSlot, isReservedSlot } from "components/reservationSlots";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function Update() {
  const [loading, setLoading] = useState(false);
  const [mainInsurance, setMainInsurance] = useState([]);
  const [subRequestGroupData, setSubRequestGroupData] = useState([]);
  const [requestGroupData, setRequestGroupData] = useState([]);
  const [reservedDays, setReservedDays] = useState([]);
  const [reservedTimes, setReservedTimes] = useState([]);
  const [selectedSlotKey, setSelectedSlotKey] = useState("");
  const [insurance, setInsurance] = useState([]);

  const [reservedSubTimes, setReservedSubTimes] = useState([]);
  const { state } = useLocation();

  const { info } = state ?? [];
  const [information, setInformation] = useState({});

  useEffect(() => {
    if (info) {
      setInformation({
        firstName: info.firstName,
        lastName: info.lastName,
        nationalCode: info.nationalCode,
        mainInsuranceId: info.mainInsuranceId,
        mobileNumber: info.mobileNumber,
        insuranceId: info.insuranceId,
        insuranceRefCode: info.insuranceRefCode == null ? "" : String(info.insuranceRefCode),
        requestGroupId: info.requestGroupId,
        subRequestGroupId: info.subRequestGroupId,
        admissionUser: info.admissionUser,
        reservedSubTimesId: info.reservedSubTimesId,
        reservationDate: info.reservationDate,
        reservationTime: info.reservationTime,
        tel: info.tel,
        age: info.age,
        weight: info.weight,
      });
    }
  }, [info]);
  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    if (name === "reservationTime") {
      const slot = findReservationSlot(buildReservationSlots(reservedTimes), value);
      setSelectedSlotKey(value);
      setInformation(prev => ({ ...prev, reservationTime: slot?.time || "" }));
      return;
    }
    if (name === "requestGroupId") {
      setSubRequestGroupData([]);
      setReservedDays([]);
      setReservedTimes([]);
      setReservedSubTimes([]);
      setSelectedSlotKey("");
      setInformation(prev => ({ ...prev, requestGroupId: value, subRequestGroupId: "", reservationDate: "", reservationTime: "" }));
      return;
    }
    if (name === "subRequestGroupId") {
      setReservedDays([]);
      setReservedTimes([]);
      setReservedSubTimes([]);
      setSelectedSlotKey("");
      setInformation(prev => ({ ...prev, subRequestGroupId: value, reservationDate: "", reservationTime: "" }));
      return;
    }
    if (name === "reservationDate") {
      setReservedTimes([]);
      setReservedSubTimes([]);
      setSelectedSlotKey("");
      setInformation(prev => ({ ...prev, reservationDate: value, reservationTime: "" }));
      return;
    }
    setInformation(prev => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    setLoading(true);
    getInsurance(1, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else return setInsurance(data);
    });
    getInsurance(0, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else return setMainInsurance(data);
    });
    getRequestGroup((isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        return setRequestGroupData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (information.requestGroupId) {
      setLoading(true);
      getSubRequestGroup(information.requestGroupId, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          setSubRequestGroupData(data);
        }
      });
    }

  }, [information.requestGroupId]);

  useEffect(() => {
    if (information.requestGroupId && information.subRequestGroupId) {
      setLoading(true);
      getReservedDays(information.requestGroupId, information.subRequestGroupId, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          setReservedDays(data);
        }
      });
    }
  }, [information.requestGroupId, information.subRequestGroupId]);

  useEffect(() => {
    let cancelled = false;
    if (information.requestGroupId && information.subRequestGroupId && information.reservationDate) {
      setLoading(true);
      getReservedTimesNoDayId(information.requestGroupId, information.subRequestGroupId, information.reservationDate, (isOk, data) => {
        if (cancelled) return;
        if (!isOk) {
          setLoading(false);
          return toast.error(data?.message);
        }
        const spans = Array.isArray(data) ? data : [];
        setReservedTimes(spans);
        if (!spans.length) {
          setLoading(false);
          setReservedSubTimes([]);
          return;
        }
        getReservedSubTimes(information.requestGroupId, information.reservationDate, information.subRequestGroupId, (success, booked) => {
          if (cancelled) return;
          setLoading(false);
          if (!success) return toast.error(booked?.message);
          setReservedSubTimes(Array.isArray(booked) ? booked : []);
        }, true);
      });
    }
    return () => { cancelled = true; };
  }, [information.requestGroupId, information.subRequestGroupId, information.reservationDate]);

  const subTimesList = buildReservationSlots(reservedTimes);
  const existingSlot = findInitialReservationSlot(subTimesList, information.reservationTime, info?.reservationDayId);
  const selectedSlot = findReservationSlot(subTimesList, selectedSlotKey) || (!selectedSlotKey ? existingSlot : undefined);
  const selectedValue = selectedSlot?.key || "";

  const submit = () => {
    if (!selectedSlot || isReservedSlot(selectedSlot, reservedSubTimes)) {
      return toast.error("لطفاً یک ساعت آزاد و معتبر برای نوبت انتخاب کنید.");
    }
    setLoading(true);
    const reserveData = {
      reservationDayId: selectedSlot.reservationDayId,
      requestGroupId: information.requestGroupId,
      subRequestGroupId: information.subRequestGroupId,
      subTime: selectedSlot.time,
      reservationDate: information.reservationDate,
      endReservationTime: selectedSlot.endReservationTime
    };
    addReservedSubTimes(reserveData, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        reserveSubTime({ reservedSubTimesId: data[0].reservedSubTimesId, isTransfer: true }, (isOk, resData) => {
          if (!isOk) {
            setLoading(false);
            return toast.error(resData.message);
          } else {
            let groupName = `${requestGroupData.find(item => item.requestGroupId == information.requestGroupId).nameGroup} - ${subRequestGroupData.find(item => item.subRequestGroupId == information.subRequestGroupId).subNameGroup}`;
            updatePatientInformation(info.patientId, {
              ...information,
              reservedSubTimesId: data[0].reservedSubTimesId,
              groupName,
            }, (isOk, data) => {
              if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
              } else {
                setLoading(false);
                toast.error("اطلاعات ویرایش شد!");
                window.location.replace("/reservationList");
              }
            });
          }
        });
      }
    });
  };

  const submitUpdateInfo = () => {
    setLoading(true);
    let groupName = `${requestGroupData.find(item => item.requestGroupId == information.requestGroupId).nameGroup} - ${subRequestGroupData.find(item => item.subRequestGroupId == information.subRequestGroupId).subNameGroup}`;
    updatePatientInformation(info.patientId, {
      ...information,
      groupName,
    }, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        toast.error("اطلاعات ویرایش شد!");
        window.location.replace("/reservationList");
      }
    });
  };
  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <MDBox pt={2} mb={6}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <MDTypography variant="h6" color="white">
                  ویرایش اطلاعات بیمار
                </MDTypography>
                <DashboardNavbar />
              </MDBox>
              <Grid container spacing={2.5} py={2} px={{ xs: 2, md: 3 }} sx={{ alignItems: "center" }}>
                <Grid item xs={12}>
                  <MDBox sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, mb: 1 }}>
                    <MDBox sx={{ width: 30, height: 30, borderRadius: 2, bgcolor: "#e7f0ff", color: "#1976d2", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>۱</MDBox>
                    <MDTypography variant="h6">اطلاعات بیمار</MDTypography>
                  </MDBox>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth value={information.firstName} name="firstName" onChange={handleChangeInputs}
                           type="text" label="نام" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth value={information.lastName} name="lastName" onChange={handleChangeInputs}
                           type="text" label="نام خانوادگی" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth value={information.nationalCode} name="nationalCode" onChange={handleChangeInputs}
                           type="text" label="کدملی" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth type="tel" value={information.mobileNumber} name="mobileNumber"
                           onChange={handleChangeInputs} label="موبایل" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput type="tel" fullWidth value={information.tel} name="tel" onChange={handleChangeInputs}
                           label="تلفن" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput type="tel" fullWidth value={information.weight} name="weight" onChange={handleChangeInputs}
                           label="وزن" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput type="tel" fullWidth value={information.age} name="age" onChange={handleChangeInputs}
                           label="سن" />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth value={information.admissionUser} name="admissionUser"
                           onChange={handleChangeInputs}
                           label="کاربر پذیرش" />
                </Grid>
                <Grid item xs={12}>
                  <MDBox sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                    <MDBox sx={{ width: 30, height: 30, borderRadius: 2, bgcolor: "#e7f0ff", color: "#1976d2", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>۲</MDBox>
                    <MDTypography variant="h6">اطلاعات بیمه</MDTypography>
                  </MDBox>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <InputLabel>نوع بیمه درمانی</InputLabel>
                    <Select label="نوع بیمه درمانی" sx={{ height: "44.3px" }}
                            value={String(information.mainInsuranceId)}
                            name="mainInsuranceId" onChange={handleChangeInputs}>
                      {mainInsurance && mainInsurance.map((item) =>
                        <MenuItem key={item.idInsurance} value={item.idInsurance}>{item.InsuranceName}</MenuItem>,
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <InputLabel>بیمه تکمیلی</InputLabel>
                    <Select label="بیمه تکمیلی" sx={{ height: "44.3px" }} value={String(information.insuranceId)}
                            name="insuranceId" onChange={handleChangeInputs}>
                      {insurance && insurance.map((item) =>
                        <MenuItem key={item.idInsurance} value={item.idInsurance}>{item.InsuranceName}</MenuItem>,
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <MDInput fullWidth type="text" name="insuranceRefCode" label="کد رهگیری بیمه (اختیاری)"
                    inputProps={{ inputMode: "numeric" }} value={information.insuranceRefCode ?? ""}
                    onChange={handleChangeInputs} />
                </Grid>
                <Grid item xs={12}>
                  <MDBox sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                    <MDBox sx={{ width: 30, height: 30, borderRadius: 2, bgcolor: "#e7f0ff", color: "#1976d2", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>۳</MDBox>
                    <MDTypography variant="h6">خدمت و زمان نوبت</MDTypography>
                  </MDBox>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <Select value={String(information.requestGroupId)} name="requestGroupId"
                            onChange={handleChangeInputs}
                            sx={{ height: "44.3px" }}>
                      <MenuItem value="">
                        <p>انتخاب درخواست</p>
                      </MenuItem>
                      {requestGroupData.map((item) => (
                        <MenuItem key={item.requestGroupId} value={item.requestGroupId}>{item.nameGroup}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <Select value={String(information.subRequestGroupId)} name="subRequestGroupId"
                            onChange={handleChangeInputs} displayEmpty disabled={!information.requestGroupId}
                            sx={{ height: "44.3px" }}>
                      <MenuItem value="">
                        <p>انتخاب خدمت</p>
                      </MenuItem>
                      {subRequestGroupData.map((item) => (
                        <MenuItem key={item.subRequestGroupId}
                                  value={item.subRequestGroupId}>{item.subNameGroup}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <Select value={String(information.reservationDate)} name="reservationDate"
                            onChange={handleChangeInputs} displayEmpty disabled={!information.requestGroupId}
                            sx={{ height: "44.3px" }}>
                      <MenuItem value="">
                        <p>روز های نوبت دهی</p>
                      </MenuItem>
                      {reservedDays.map((item, index) => (
                        <MenuItem key={index}
                                  value={item.reservationDate}>{`${String(item.reservationDate).slice(0, 4)}/${String(item.reservationDate).slice(4, 6)}/${String(item.reservationDate).slice(6)}`}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <FormControl fullWidth>
                    <Select value={selectedValue} name="reservationTime"
                            onChange={handleChangeInputs} displayEmpty disabled={!information.reservationDate}
                            sx={{ height: "44.3px" }}>
                      <MenuItem value="">
                        <p>زمان نوبت دهی</p>
                      </MenuItem>
                      {subTimesList.map((item, index) => (
                        <MenuItem disabled={isReservedSlot(item, reservedSubTimes)} key={item.key}
                                  value={item.key}>{item.time}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <MDBox mx={{ xs: 2, md: 3 }} my={2} p={2} sx={{ borderRadius: 2, bgcolor: "#f3f7fc", border: "1px solid #e4ebf4" }}>
                <MDTypography variant="subtitle2" sx={{ mb: 0.5 }}>خلاصه نوبت</MDTypography>
                <MDTypography variant="body2" color="text">
                  {[information.firstName, information.lastName].filter(Boolean).join(" ") || "بیمار"}
                  {" | "}{information.reservationDate ? String(information.reservationDate).replace(/^(\d{4})(\d{2})(\d{2})$/, "$1/$2/$3") : "تاریخ انتخاب نشده"}
                  {" | "}{information.reservationTime || "ساعت انتخاب نشده"}
                </MDTypography>
              </MDBox>
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8, padding: "0 16px 20px" }}>
                <MDButton variant="gradient" onClick={submit} disabled={loading} color="success" sx={{ width: "120px", margin: "1rem" }}>
                  ویرایش نوبت
                </MDButton>
                <MDButton variant="gradient" onClick={submitUpdateInfo} disabled={loading} color="info"
                          sx={{ margin: "1rem" }}>
                  ویرایش اطلاعات
                </MDButton>
              </div>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>

  );
}
